import { ChangeDetectorRef, Component } from '@angular/core';

import { combineLatest, map, Observable, startWith } from 'rxjs';

import { ReadableDatePipe } from '../../../../pipes/readable-date-pipe';
import { DateCellOptions } from '../../../../record/entities/cell-options/cell-options.entity';
import { Task } from '../../../entities/task.entity';
import { TaskDtoCellComponent } from '../task-dto-cell.component';

@Component({
    standalone: false,
    selector: 'digihaven-task-deadline-cell',
    templateUrl: './task-deadline-cell.component.html'
})
export class TaskDeadlineCellComponent extends TaskDtoCellComponent<DateCellOptions> {
    readonly valueAsDate$: Observable<string>;

    constructor(cd: ChangeDetectorRef, readableDatePipe: ReadableDatePipe) {
        super(cd);

        this.valueAsDate$ = combineLatest([
            this.value$,
            this.options$.pipe(startWith({ full: false }))
        ]).pipe(map(([date, options]) => readableDatePipe.transform(date, options.full)));
    }

    protected readFromTask(task: Task): string | undefined {
        return task.task.DueDate;
    }
}
